
class TopupProduct {
    public readonly id: string;
    public readonly name: string;
    public readonly amount: number;
    public readonly enabled: boolean;

    constructor(id: string, name: string, amount: number, enabled: boolean) {
        this.id = id;
        this.name = name;
        this.amount = amount;
        this.enabled = enabled;
    }
}

export default TopupProduct;